import { Injectable } from '@angular/core';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { JobsService } from './jobs-service';

@Injectable({
  providedIn: 'root',
})
export class StatesResolver {
  constructor(
    private jobsService: JobsService,
    private applicationModel: ApplicationModel
  ) {}

  load(): Promise<typeof this.applicationModel.states> {
    if (this.applicationModel.states.length === 0) {
      return this.jobsService
        .getStates()
        .then(
          (data: { Data: typeof this.applicationModel.states }) =>
            (this.applicationModel.states = data.Data)
        );
    }

    return Promise.resolve(this.applicationModel.states);
  }
}
